'use client';

import { useEffect } from 'react';
import { connectExec } from '@/lib/ws-client';
import { MobileHeader } from '@/components/mobile-header';
import { FooterDisclaimer } from '@/components/footer-disclaimer';
import { AgeGate } from '@/components/age-gate';

export default function PublicLayout({ children }: { children: React.ReactNode }) {
  useEffect(() => connectExec(), []);
  return (
    <div className="min-h-screen flex flex-col">
      <MobileHeader />
      <main className="flex-1 mx-auto w-full max-w-6xl px-4 py-4">{children}</main>
      <FooterDisclaimer />
      <AgeGate />
    </div>
  );
}
